
import { computed, defineComponent, onMounted, reactive, toRefs } from 'vue';
import { usePaymentForm } from './usePaymentForm';
import ModalTemplate from '../modal-template/template.vue';

export default defineComponent({
  components: {
    [ModalTemplate.name]: ModalTemplate,
  },
  setup() {
    const {
      state,
      handleTokenizingResponse,
      onCountryChange,
      payingWithCredit,
      payingWithACH,
      isCanadianVersion,
      setNewPaymentMethod,
      selectCreditCard,
      selectACHAccount,
      availableCredits,
      creditsCoverTotalCost,
      totalPaid,
      calculateCreditCardFee,
      calculateTotalWithoutCreditCardFee,
      calculateTotalWithCreditCardFee,
      baseValidationsFailed,
      deleteCredit,
      unableToAddCredit,
      addCredit,
      isNewCreditCard,
      onCreditCardSelectChange,
      onAchSelectChange,
      isNewAchAccount,
    } = usePaymentForm();

    onMounted(() => {
      state.invoiceOnlyMode = $("#invoice_only").val() == "true";
      state.invoiceEnabled = $("#invoice_enabled").val() == "true";
    });    

    const disableForm = computed(() => {
      if(baseValidationsFailed()){
        return true;
      }
      if (state.paymentType == 'pay_by_invoice') {
        return invoice_limit_isnt_enough.value;
      }
      return false;
    });

    const invoice_limit_isnt_enough = computed(() => {
      let invoice_limit = Number(document.getElementById('invoice_limit').value);
      return state.paymentType == 'pay_by_invoice' && invoice_limit < calculateTotalWithoutCreditCardFee();
    });

    const payingWithDirectDeposit = computed(() => state.paymentType == 'pay_by_deposit' ? 1 : 0);
    const payingWithInvoice = computed(() => state.paymentType == 'pay_by_invoice' ? 1 : 0);

    const selectDirectDeposit = () => {
      setNewPaymentMethod("pay_by_deposit");
      state.billing_address = true;
    };

    const selectInvoice = () => {      
      setNewPaymentMethod("pay_by_invoice");
      state.billing_address = false;
      if(state.poNumber == null){
        state.poNumber = $("#default_po_number").val();
      }      
    };

    return { 
      ...toRefs(state), 
      disableForm, 
      payingWithCredit, 
      payingWithACH, 
      payingWithDirectDeposit,
      payingWithInvoice,
      isCanadianVersion,
      invoice_limit_isnt_enough,
      onCountryChange,
      unableToAddCredit,
      addCredit,
      deleteCredit,
      availableCredits,
      creditsCoverTotalCost,
      setNewPaymentMethod,
      selectCreditCard,
      calculateTotalWithCreditCardFee,
      calculateTotalWithoutCreditCardFee,
      totalPaid,
      calculateCreditCardFee,
      selectACHAccount,
      selectDirectDeposit,
      selectInvoice,
      handleTokenizingResponse,
      isNewCreditCard,
      onCreditCardSelectChange,
      onAchSelectChange,
      isNewAchAccount,
    };
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleTokenizingResponse);
  },
});
